<script setup>
const props = defineProps({
  fillColor: { type: String, default: '#fff' },
  strokeColor: { type: String, default: '#fff' },
})
</script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.22896 20.6598C7.24388 20.7264 7.26463 20.7924 7.29136 20.8569C7.47709 21.3053 7.91466 21.5976 8.40001 21.5976H15.6C16.0854 21.5976 16.5229 21.3053 16.7087 20.8569C16.8944 20.4085 16.7917 19.8923 16.4485 19.5491L15.4836 18.5841L15.3369 17.9977H18C19.3255 17.9977 20.4 16.9231 20.4 15.5977V7.48883L18 9.88883V14.3977H13.5273C13.5154 14.3974 13.5034 14.3973 13.4914 14.3974L7.22896 20.6598ZM16.8 5.99766H5.99998V14.3977H8.39998L5.01208 17.7856C4.17937 17.409 3.59998 16.571 3.59998 15.5977V5.99766C3.59998 4.67217 4.67449 3.59766 5.99998 3.59766H18C18.3521 3.59766 18.6866 3.67351 18.9879 3.80976L16.8 5.99766Z"
      :fill="fillColor"
    />
    <line
      x1="22.2364"
      y1="1.83561"
      x2="3.03637"
      y2="21.0356"
      :stroke="strokeColor"
      stroke-width="1.8"
    />
  </svg>
</template>
